var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    _vm.p.tag,
    _vm._b(
      {
        tag: "component",
        staticClass: "vuDropdownTrigger",
        class: { "vuDropdownTrigger--disabled": _vm.p.api.isDisabled },
        attrs: {
          id: _vm.p.id,
          "aria-haspopup": "true",
          tabindex: _vm.p.api.isDisabled ? "-1" : null,
          "aria-disabled": _vm.p.api.isDisabled ? "true" : null,
          "aria-expanded": _vm.p.api.isOpen ? "true" : "false",
        },
        on: {
          click: function ($event) {
            $event.preventDefault()
            $event.stopPropagation()
            return _vm.p.toggle()
          },
          keydown: _vm.onKeyDown,
          keyup: function ($event) {
            $event.preventDefault()
            $event.stopPropagation()
            return _vm.onKeyUp.apply(null, arguments)
          },
        },
      },
      "component",
      _vm.attr,
      false
    ),
    [_vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }